// extracted by mini-css-extract-plugin
export default {"root":"i1v5O"};